export default class LatLngOverlay extends TMap.DOMOverlay {
  constructor(options) {
    super(options);
  }
  // 初始化：获取配置参数
  onInit(options: { position: LatLng }) {
    this.position = options.position;
  }

  // 创建DOM元素，返回一个Element，使用this.dom可以获取到这个元素
  createDOM() {
    const dom = document.createElement('div');
    dom.innerText = `${this.position.lat.toFixed(6)},${this.position.lng.toFixed(6)}`;
    // dom.setAttribute('class', 'getpoint-position-label');
    // const positionLabel = this.createPositionLabel(this.options);
    dom.setAttribute(
      'style',
      `background: rgba(0,0,0,0.70);
position: absolute;
left: 0;
top: 0;
box-shadow: 0 4px 10px 0 rgba(31,34,38,0.07);
display: inline-block;
border-radius: 4px;
height: 26px;
box-sizing: border-box;
padding: 0px 8px;
line-height: 26px;
font-size: 14px;
color: #FFFFFF;`,
    );
    return dom;
  }

  updatePosition(val: LatLng) {
    this.position = val;
  }

  // 更新DOM元素，在地图移动/缩放后执行
  updateDOM() {
    if (!this.map) {
      return;
    }
    // const positionLabel = this.dom.querySelector('.getpoint-position-label');
    this.dom.innerText = `${this.position.lat.toFixed(6)},${this.position.lng.toFixed(6)}`;
    const pixel = this.map.projectToContainer(this.position); // 经纬度坐标转容器像素坐标
    const left = `${pixel.getX() + 10}px`;
    const top = `${pixel.getY() + 10}px`;
    // 使用top/left将DOM元素定位到指定位置
    // this.dom.style.top = top;
    // this.dom.style.left = left;
    this.dom.style.transform = `translate(${left}, ${top})`;
  }

  // 销毁时
  onDestroy() {
    this.dom?.remove();
  }
}
